export default __webpack_public_path__ + "static/torres-strait-flag-aef0540607072f1ce16f935008c2924e.svg";